import { Divider } from '@material-ui/core'
import React from 'react'
import { Header, Row, Text } from '../Text'

function Integrations({ bookingCount, iCalendarCount }: IIntegrationsProps) {
  return (
    <React.Fragment>
      <Header>Integracje</Header>
      <Divider />
      <Row>
        <Text>Booking ilość pokojów: {bookingCount}</Text>
      </Row>
      <Row>
        <Text>iCalendar ilość pokojów: {iCalendarCount}</Text>
      </Row>
    </React.Fragment>
  )
}

export default Integrations

export interface IIntegrationsProps {
  bookingCount: number
  iCalendarCount: number
}
